import { ADJUST_CAROUSEL_BOTTOM_HEIGHT } from 'actions';
import { CarouselReduxReducer } from 'typings';

export function adjustCarouselBottomHeight(
  reduxReducer: CarouselReduxReducer,
  heightDelta: number,
) {
  return { heightDelta, reduxReducer, type: ADJUST_CAROUSEL_BOTTOM_HEIGHT };
}
